/**
 * Informazioni sul Travel Advisor
 */
export interface IAdvisorInfo {
  id?: string;
  firstName: string;
  lastName: string;
  email: string;
  // Stripe Connect fields
  stripeAccountId?: string | null;
  stripeChargesEnabled?: boolean;
  stripeAccountStatus?: 'not_connected' | 'pending' | 'active' | 'restricted' | null;
}

/**
 * Classe che rappresenta le informazioni di un Travel Advisor
 */
export class AdvisorInfo implements IAdvisorInfo {
  id?: string;
  firstName: string;
  lastName: string;
  email: string;
  // Stripe Connect fields
  stripeAccountId?: string | null;
  stripeChargesEnabled?: boolean;
  stripeAccountStatus?: 'not_connected' | 'pending' | 'active' | 'restricted' | null;

  constructor(data: {
    id?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    // Stripe Connect fields
    stripeAccountId?: string | null;
    stripeChargesEnabled?: boolean;
    stripeAccountStatus?: 'not_connected' | 'pending' | 'active' | 'restricted' | null;
  }) {
    this.id = data.id;
    this.firstName = data.firstName || '';
    this.lastName = data.lastName || '';
    this.email = data.email || '';
    this.stripeAccountId = data.stripeAccountId;
    this.stripeChargesEnabled = data.stripeChargesEnabled;
    this.stripeAccountStatus = data.stripeAccountStatus;
  }

  /**
   * Nome completo del Travel Advisor
   */
  get fullName(): string {
    return `${this.firstName} ${this.lastName}`.trim();
  }

  /**
   * Verifica se l'advisor ha dati validi
   */
  get isValid(): boolean {
    return !!(this.firstName && this.lastName && this.email);
  }
}
